import type { ReferralItem } from './referral-item'

export class Referral {
    person: any
    referralId: string
    companyId: string
    userId: string
    personId: string
    createdAt: Date
    updatedAt: Date
    syncAt: Date
    total: number
    contacted: number
    replied: number
    scheduled: number
    attended: number
    converted: number
    revenue: number
    status: number
    items?: ReferralItem[] = []
    allowCustomer?: boolean
}
